import api from "../utils/api";

export const getTranslations = async () => {
  const response = await api.get("/traduction");
  return response.data;
};